import { render, staticRenderFns } from "./InProgress2.vue?vue&type=template&id=0fa6f651&"
import script from "./InProgress2.vue?vue&type=script&lang=js&"
export * from "./InProgress2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports